_collow.components.FinishCourse = class FinishCourse extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  registrationId;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.registrationId = localStorage.getRegistrationId();

    if (this.params.type == "quiz") {
      this.listen(
        document.body,
        "_collow.finish-final-quiz",
        this.finishCourseCheck
      );
      return;
    }
    this.finishCourseCheck();
  }

  /**
   * preparing the finishing of the course
   */
  finishCourseCheck = async () => {
    const validFinish = await this.checkCompletable();
    if (!validFinish) return;
    if (validFinish == true) {
      this.root.removeAttribute("hidden");
      this.listen(this.root, "click", this.sendCourseFinished);
    }
    if (typeof validFinish == "string") {
      this.dispatch(this.root, "_collow.error-with-input", {
        err: [validFinish],
      }); //error
      this.dispatch(
        this.root,
        "_collow.hide-all-quiz",
        `<a class="course__link" href="/${validFinish}">${validFinish}</a>`
      );
    }
  };

  /**
   * Check course can be finished
   * @returns a href string if items need to be completed, true if finishiable, false if already completed and redirects to login if other error from be.
   */
  checkCompletable = async () =>
    await fetch(
      this.params.path +
      `/course_registration/${this.registrationId}/completable`,
      {
        method: "get",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    )
      .then(async (response) => {
        if (!response.ok) throw await response.json();
        return true;
      })
      .catch((err) => {
        if (
          err?.detail?.["error_code"] ==
          "course_registration_prereq_not-finished"
        )
          return `course/${this.courseName}/${err.detail.info}`;
        if (
          err?.detail?.["error_code"] == "course_registration_already-completed"
        )
          return false;
        if (err?.detail?.["error_code"]) window.location.pathname = "login"; // in this case its not own r
      });

      getCourseFinishText() {
        const coursesLessonsContainer = document.querySelector('.course-lesson');
        return {
          messageCourseFinished: coursesLessonsContainer?.dataset?.messageCourseFinished,
          buttonCourseFinished: coursesLessonsContainer?.dataset?.buttonCourseFinished,
        };
      }

  /**
   * Handeler for clicking the finish button
   * @returns
   */
  sendCourseFinished = async () => {
    const { messageCourseFinished, buttonCourseFinished } = this.getCourseFinishText();
    
    const result = await fetch(
      this.params.path + `/course_registration/${this.registrationId}/complete`,
      {
        method: "put",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    )
      .then(async (response) => {
        if (!response.ok) throw await response.json();
        return true;
      })
      .catch((err) => {
        if (
          err.detail["error_code"] == "course_registration_not-found" ||
          err.detail["error_code"] == "course_registration_not-own-registration"
        )
          window.location.pathname = "login";
        return false;
      });
    if (!result) return;

    await this.fetchPogressJson();

    const finishText = `
    <h1>${messageCourseFinished || "Congratulations, you have completed the course!!"}</h1>
    <button class="button-1" id="finishButton" onclick="window.location.href = window.location.origin + '/profile'">${buttonCourseFinished || 'Finish!'}</button>`;
    this.dispatch(this.root, "_collow.error-with-input", {
      err: [finishText],
      clear: true,
    }); //temporary, soon will be redirect
    this.dispatch(this.root, "_collow.course-completed");
  };

  /**
   * Fetch the progressJson from the server
   * so the user can see the course is completed
   * and the progress is updated
   */
  fetchPogressJson = async () => {

    const progressJson = await fetch(this.params.path + "/user/me", {
      method: "get",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }).then((response) => response.json());

    localStorage.setItem("progressJson", JSON.stringify(progressJson));
    document.cookie = `_r=${progressJson.role}`;

  };
};
